module.exports = __webpack_public_path__ + "static/media/NY_Times_logo.5ca79c73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NY_Times_logo.png
// module id = 283
// module chunks = 0